module.exports = __webpack_public_path__ + "static/img/ban.6d784f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutUs/img/ban.jpg
// module id = RJK8
// module chunks = 1